import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import { Grid } from '@mui/material';
import css from './PartnersPage.module.css';
function importAll(r) {
  let images = {};
  r.keys().map(item => { images[item.replace('./', '')] = r(item); });
  return images;
}

const images = importAll(require.context('./logos', false, /\.jpg/));


const PartnersPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const numbersArray = [];

  for(let i = 1; i <= 62; i++){
    numbersArray.push(i)
  }
  // prettier-ignore
  return (
    <StaticPage
      title="Partners"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'PartnersPage',
        description: 'Partners',
        name: 'Partners',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>

          <h1 className={css.pageTitle}>Coverage, supporters, partners</h1>

          <p>This is only a selection of organizations and media outlets, which support us by means of press coverage, donations, free use of their services or voluntary work. We thank everyone involved for their outstanding work!</p>
          
          <p>
            Further help is always welcome – we are happy, if you reach out!
            <br/>For partners: <a href="mailto:partner@host4ukraine.com">partner@host4ukraine.com</a>
            <br/>For press: <a href="mailto:press@host4ukraine.com">press@host4ukraine.com</a>
            <br/>For donors: <a href="mailto:give@hast4ukraine.com">give@hast4ukraine.com</a>
          </p>
          
          <Grid container item xs={12} justifyContent='center' style={{marginTop: '4pc'}}>
                {numbersArray.map(n => {
                  
                  return(
                    <Grid container item xs={12} sm={6} md={4} lg={3} justifyContent='center'>
                        <img src={images[`Web 1280 ΓÇô ${n}.jpg`]?.default} className={css.logoImage} />
                    </Grid>
                  )
                })}
          </Grid>

           
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default PartnersPage;
